import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-button-spinner',
  templateUrl: './button-spinner.component.html',
  styleUrls: ['./button-spinner.component.scss'],
})
export class ButtonSpinnerComponent {
  @Input() label?: string;
  @Input() disabled?: boolean;
  @Input() loading?: boolean;
  @Input() isSubmitButton = false;
  @Input() isPrimaryButton: boolean = true;
  @Output() public clickBtn = new EventEmitter();

  constructor() {}

  public onButtonClick() {
    this.clickBtn.emit();
  }
}
